import { render, staticRenderFns } from "./CertificateImportFailureBanner.vue?vue&type=template&id=a6ed478c"
import script from "./CertificateImportFailureBanner.vue?vue&type=script&lang=js"
export * from "./CertificateImportFailureBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports